import type { IPublicClientApplication } from "@azure/msal-browser";
import { loginRequest } from "@/microsoftAuthConfig";

let msalInstance: IPublicClientApplication | null = null;

export function setMsalInstance(instance: IPublicClientApplication) {
  msalInstance = instance;
}

export async function acquireMsalToken(): Promise<string> {
  if (!msalInstance) {
    throw new Error("MSAL instance has not been initialized.");
  }

  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!account) {
    throw new Error("No active MSAL account.");
  }

  const result = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account,
    forceRefresh: true,
  });

  return result.idToken;
}
